/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
    let currentPercent = 0; // Store the current percentage globally
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.updateStatus();
      }
  
      updateStatus() {
        const remainingAmountText = this.querySelector('.free-shipping__info-text strong');
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const isCountryOverride = this.dataset.isOverride === 'true';
        const rawShippingAmount = parseInt(this.dataset.shippingAmount, 10);
        // A country-specific amount is already in the visitor's local currency; only
        // convert the generic default (entered in the store's main currency) using the
        // live exchange rate.
        const freeShippingThreshold = isCountryOverride
          ? rawShippingAmount
          : Math.round(rawShippingAmount * (Shopify.currency.rate || 1));
        const remainingInfo = this.querySelector('.free-shipping__info-text');
        const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
        const isEligible = cartTotal >= freeShippingThreshold;
  
        if (remainingAmountText && !isEligible) {
          const remainingAmount = freeShippingThreshold - cartTotal;
          const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
          remainingAmountText.innerHTML = formatMoney(remainingAmount, currencyFormat);
        }
  
        remainingInfo.style.display = isEligible ? 'none' : 'block';
        eligibilityInfo.style.display = isEligible ? 'block' : 'none';
  
        const progressPercentage = isEligible ? 1 : cartTotal / freeShippingThreshold;
        this.animateProgressBar(progressPercentage);
      }
  
      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = currentPercent;
        const duration = 200;
        const startTime = performance.now();
  
        const ease = (t) => t * (2 - t); 
  
        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);
  
          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${currentPercent}%`);
  
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            currentPercent = targetPercent; 
            this.style.setProperty('--percent', `${currentPercent}%`);
          }
        };
  
        requestAnimationFrame(animate);
      }
    }
  
    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}

/**
 * Corrects any "{{ amount }}" free-shipping figure rendered outside the cart
 * (e.g. the announcement bar) that wasn't tied to a specific country override,
 * by applying the live exchange rate client-side. Country-specific amounts are
 * already in the visitor's local currency and are left untouched.
 */
function updateFreeShippingAmounts() {
  document.querySelectorAll('.announcement-free-shipping-amount[data-is-override="false"]').forEach((el) => {
    const cents = parseInt(el.dataset.freeShippingCents, 10);
    if (!cents || typeof Shopify === 'undefined' || !Shopify.currency) return;
    const convertedCents = Math.round(cents * (Shopify.currency.rate || 1));
    const currencyFormat = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || "${{amount}}";
    el.innerHTML = formatMoney(convertedCents, currencyFormat);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateFreeShippingAmounts);
} else {
  updateFreeShippingAmounts();
}